import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import "./EventDetails.css";
import calendarIcon from "./assets/svg/date.svg";
import locationIcon from "./assets/svg/location.svg";
import placeholder from "./assets/image.png";
import UpcomingEvents from "../UpcomingEvents";

export default function EventDetails() {
  const { slug } = useParams();
  const [event, setEvent] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`https://beszeljegyesulet.hu/wp/wp-json/wp/v2/events?slug=${slug}`)
      .then((res) => res.json())
      .then((data) => {
        console.log("Esemény adatok:", data[0]);
        setEvent(data[0]);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Hiba az esemény betöltésekor:", err);
        setLoading(false);
      });
  }, [slug]);

  if (loading) return <div className="loading">Betöltés...</div>;
  if (!event) return <div className="error">Nem található az esemény.</div>;

  // === FEATURED IMAGE FIXED ===
  const featured = event.featured_image_url || placeholder;

  // === DATE FORMATTING ===
  const rawDate =
    event.acf?.event_date ||
    event.meta?.event_date ||
    "Dátum nem elérhető";

  let eventDate = rawDate;

  const match = rawDate.match(/^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2}))?/);
  if (match) {
    const [_, year, month, day, hour, minute] = match;
    const dateObj = new Date(year, month - 1, day, hour || 0, minute || 0);

    eventDate = dateObj.toLocaleDateString("hu-HU", {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: hour ? "2-digit" : undefined,
      minute: minute ? "2-digit" : undefined,
    });

    eventDate = eventDate.charAt(0).toLowerCase() + eventDate.slice(1);
  }

  const eventLocation =
    event.acf?.event_location ||
    event.meta?.event_location ||
    "Helyszín nem elérhető";

  return (
    <main className="event-details">
      <section className="event-hero">
        <img src={featured} alt={event.title.rendered} className="event-hero-img" />
      </section>

      <section className="event-content container">
        <div className="event-meta">
          <div className="event-meta-item">
            <img src={calendarIcon} alt="Dátum ikon" />
            <span>{eventDate}</span>
          </div>
          <div className="event-meta-item">
            <img src={locationIcon} alt="Helyszín ikon" />
            <span>{eventLocation}</span>
          </div>
        </div>

        <h1
          className="event-title"
          dangerouslySetInnerHTML={{ __html: event.title.rendered }}
        ></h1>

        <div
          className="event-description"
          dangerouslySetInnerHTML={{ __html: event.content.rendered }}
        ></div>
      </section>

      <section className="event-upcoming">
        <h2 className="section-heading">Következő események</h2>
        <UpcomingEvents />
      </section>
    </main>
  );
}
